<app-filter-multi-select
  [label]="label"
  icon="flag"
  [options]="options"
  [selected]="selected"
  [emptyLabel]="emptyLabel"
  [controlClass]="controlClass"
  [disabled]="disabled"
  (selectedChange)="onSelectedChange($event)"
></app-filter-multi-select>
